module.exports = function(app) {
    require("./custom-landing/member-login")(app);
    app.controller('pages.customLanding', ["$window", "$scope", "services", "sessionData", "$location",
        function($window, $scope, services, sessionData, $location) {
            $window.document.title = "Home";

            $scope.guideWellRedirect = $location.search().returnTo;
            $scope.nonGuideWellHeading = true;
            if ($scope.guideWellRedirect === '/emssvc/x-services/secure/sso/outbound/auto/v1/vendor/GUIDEWELLMEMBER') {
                $scope.nonGuideWellHeading = false;
                $scope.guideWellHeading = true;
                $scope.sidebar = { description: '<span data-aem-content="HOM_CUSTOMLANDING_GUIDEWELL_DESCRIPTION"></span> ' };
            } else {
            $scope.showSection = false;
            $scope.sidebar = {
               // description: '<span data-aem-content="MBR_CUSTOM_CLIENT_LOGIN as content">{{content.leftNav.description}}</span>'
                description: 'Log in for info about your current coverage, claims, accounts and more.'
            };
            if (sessionData.loggedIn) {
                    $window.location = "/member/home";
            }
        }
        }
    ]);
    return [
        {
            state: "customLanding",
            appConfigMaintenanceApp: "SPLASH",
            appConfigMaintenanceKey: "CUSTOM_LANDING",
            url: "/custom-landing",
            views: {
                'body@': {
                    //template: require('pages/custom-landing.html'),
                    templateUrl: 'custom-landing.appTemplate.html/chmhom/pages/custom-landing',
                    controller: "pages.customLanding"
                },
                "content@customLanding": {
                    //template: require('pages/custom-landing/member-login.html'),
                    templateUrl: 'custom-landing.appTemplate.html/chmhom/pages/custom-landing/member-login',
                    controller: "pages.customLanding.memberLogin"
                }
            }
        }, {
            state: "customLanding.uom",
            url: "/:client"
        }
    ];
};
